/**
 * The two brand steps that JavaScript needs as literals.
 *
 * The ramp itself lives in `hotmathsBrand.css`, which is the single source of truth. Ant Design derives
 * hover and active shades from `colorPrimary` algorithmically and so cannot accept a `var()`, which is the
 * only reason these are duplicated here.
 *
 * Contrast, measured: `#B35A00` carries white text at 4.80:1 and `#874400` reads on the page background at
 * 7.05:1, both above the WCAG AA minimum of 4.5:1. The site's familiar `#F57C00` manages 2.70:1 and fails.
 */
export const hotmathsColors = {
    /** --color-primary-600 · buttons and active states, white text on top. */
    primary600: '#B35A00',
    /** --color-primary-800 · link text on the page background. */
    primary800: '#874400',
};

export default hotmathsColors;
